export default __webpack_public_path__ + "static/media/gallery_10.658a32a3.jpg";